@if (activeRules().length > 0) {
  <div class="alert alert-info grading-rules-alert">
    <button
      type="button"
      class="grading-rules-alert__header"
      data-testid="alert-header"
      [attr.aria-expanded]="expanded()"
      (click)="toggle()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        class="grading-rules-alert__info-icon">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>

      <span class="grading-rules-alert__title">How will this be graded?</span>

      <span class="grading-rules-alert__count" data-testid="rule-count">
        {{ ruleCountLabel() }}
      </span>

      @if (expanded()) {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          class="grading-rules-alert__chevron"
          data-testid="chevron-up">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 15l7-7 7 7" />
        </svg>
      } @else {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          class="grading-rules-alert__chevron"
          data-testid="chevron-down">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 9l-7 7-7-7" />
        </svg>
      }
    </button>

    @if (expanded()) {
      <div class="grading-rules-alert__body" data-testid="rules-body">
        @for (rule of activeRules(); track rule.id) {
          <div class="grading-rules-alert__rule">
            <span class="grading-rules-alert__check" aria-hidden="true">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="3"
                  d="M5 13l4 4L19 7" />
              </svg>
            </span>
            <span class="grading-rules-alert__rule-text">
              <strong>{{ rule.title }}</strong> &mdash; {{ rule.body }}
            </span>
          </div>
        }
      </div>
    }
  </div>
}
